export default __webpack_public_path__ + "static/media/Marianne-Light_Italic.e86f00bb.woff";